module.exports = __webpack_public_path__ + "img/BOD-message-banner.dab903b5.jpg";